module.exports = __webpack_public_path__ + "img/settings.ea571b2b.png";